import Employee from '@/resources/models/employees';
import ESPE from '@/views/constants/employee-summary-personal-edit';
import Modal from '@/shared/constants/modal';

import App from '@/views/constants/app';

import NewEmployeePersonalValidator from '@/views/validations/employee-new-personal';

const state = {
  employeeSummaryPersonalFormObject: new Employee()
};

const getters = {
  employeeSummaryPersonalFormObject: state => state.employeeSummaryPersonalFormObject,
  employeePersonalEditValidations: state => NewEmployeePersonalValidator.validate(state.employeeSummaryPersonalFormObject),
  employeePersonalEditRequiredFields: state => NewEmployeePersonalValidator.requiredFields(state.employeeSummaryPersonalFormObject)
};

const actions = {
  [ESPE.Actions.Form.CHANGE] ({ commit }, data) {
    commit(ESPE.Mutations.Form.CHANGE, data);
  },

  [Modal.Actions.OPEN] ({ commit }, data) {
    if (data.component === 'EmployeeSummaryPersonalEdit') {
      commit(ESPE.Mutations.INITIALIZE, data.employee);
    }
  }
};

const mutations = {
  [ESPE.Mutations.INITIALIZE] (state, payload) {
    state.employeeSummaryPersonalFormObject = new Employee(payload.getBody());
  },
  [ESPE.Mutations.Form.CHANGE] (state, payload) {
    state.employeeSummaryPersonalFormObject[payload.attribute] = payload.value;
  },

  [App.Mutations.CLEAR] (state) {
    state.employeeSummaryPersonalFormObject = new Employee();
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
